import type { Export } from '../../types/Export';

export const exportBaseFeatureConfig: Export = {
    hideSectionsFilter: false,
    hideSubPortfolioFilter: false,
    hideTitlesFilter: false,
    baseFields: [{ key: 'isin' }, { key: 'marketValue' }, { key: 'totalIncome' }],
    extraFields: [],
    realPortfolioFields: [
        { key: 'title' },
        { key: 'lastPrice' },
        { key: 'lastPriceDate' },
        { key: 'stockExchange' },
        { key: 'amount' },
        { key: 'performance' },
        { key: 'performancePercent' },
        { key: 'avgPurchasePrice' },
    ],
    disableFieldsByFormat: {},
};
